export default "__VITE_PUBLIC_ASSET__234b7cf8__"